<template>
  <div class="filter-type">
    <slot name="select-type-label-container" />
    <ul>
      <li v-if="items.length > 1">
        <slot name="all-label-container" />
      </li>
      <li
        v-for="(type, index) in items"
        :key="index"
        :class="{'active_type': getTypeFiltroActive(type.Extension) }"
      >
        <a
          class=""
          @click="setTypeFiltro(type.Extension)"
        >{{ type.ExtensionDescription }}</a>
      </li>
    </ul>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'media-library-filter-type',
  data() {
    return {
      items: []
    }
  },
  computed: {
    ...mapGetters({
      getMediaLibraryTypes: 'getMediaLibraryTypes',
      getCategoryId: 'getCategoryId',
      getTypeFiltro: 'getTypeFiltro',
      getTypeFiltroActive: 'getTypeFiltroActive',
      getMediaLibrary: 'getMediaLibrary',
      category: 'category',
      datasource: 'dataSource'
    })
  },
  watch: {
    getMediaLibraryTypes(values) {
      this.items = values

      this.defineFilter(this.items)
    },
    category() {
      this.setTypeFiltro('')

      this.items = _.filter(this.getMediaLibraryTypes, (item) => {
        return _.some(this.datasource, { Extension: item.Extension })
      })

      this.defineFilter(this.items)
    }
  },
  methods: {
    ...mapMutations({
      setCategoryId: 'setCategoryId',
      setTypeFiltro: 'setTypeFiltro'
    }),
    defineFilter(values) {
      if (values.length === 1) {
        this.setTypeFiltro(values[0].Extension)
      }
    }
  }
}
</script>
